module.exports = __webpack_public_path__ + "static/media/details-20-image-3.dd597c25.jpg";